(function () {
  'use strict';

  // ── Labels & descriptions ──────────────────────────────────────────────────

  var CATEGORY_LABELS = {
    phone: 'Phone',
    ipad: 'iPad / Tablet',
    macbook: 'MacBook / Laptop',
    ipod: 'iPod'
  };

  var REPAIR_LABELS = {
    'screen-repair': 'Screen Repair',
    'cover-screen-repair': 'Cover Screen Repair',
    'inner-screen-repair': 'Inner (Main) Screen Repair',
    'battery-replacement': 'Battery Replacement',
    'charging-port-repair': 'Charging Port Repair',
    'back-glass-repair': 'Back Glass Repair',
    'rear-camera-repair': 'Camera Repair',
    'camera-repair': 'Camera Repair',
    'camera-lens-repair': 'Camera Lens',
    'front-camera': 'Front Camera',
    'diagnosis': 'Diagnosis',
    'water-damage-diagnosis': 'Water Damage',
    'keyboard-repair': 'Keyboard Repair',
    'trackpad-repair': 'Trackpad Repair',
    'logic-board-repair': 'Logic Board Repair',
    'board-level': 'Board-Level Repair',
    'button-repair': 'Button Repair',
    'earpiece-repair': 'Earpiece Repair',
    'fingerprint-sensor': 'Fingerprint Sensor',
    'headphone-jack': 'Headphone Jack',
    'housing-repair': 'Housing Repair',
    'microphone-repair': 'Microphone Repair',
    's-pen': 'S Pen Repair',
    'sensor': 'Sensor Repair',
    'sim-reader': 'SIM Reader',
    'software': 'Software Fix',
    'speaker-repair': 'Speaker Repair',
    'storage': 'Storage Upgrade',
    'vibration-motor': 'Vibration Motor',
    'wifi-signal': 'Wi-Fi / Signal',
    'wireless-charging': 'Wireless Charging'
  };

  var REPAIR_DESCS = {
    'screen-repair': 'Glass, OLED, lines or touch faults',
    'cover-screen-repair': 'Cracked or faulty outer cover screen',
    'inner-screen-repair': 'Damaged inner folding display',
    'battery-replacement': 'Drains quickly or shuts off',
    'charging-port-repair': 'Loose port or no power in',
    'back-glass-repair': 'Cracked rear panel',
    'rear-camera-repair': 'Blurry photos or won\'t open',
    'camera-repair': 'Blurry photos or won\'t open',
    'camera-lens-repair': 'Scratched or cracked lens glass',
    'front-camera': 'Selfie camera blurry or not working',
    'diagnosis': 'Not sure? We\'ll find the fault',
    'water-damage-diagnosis': 'Spilled, dropped or steamed',
    'keyboard-repair': 'Keys stuck, missing or unresponsive',
    'trackpad-repair': 'Not clicking or tracking correctly',
    'logic-board-repair': 'Power, software or component fault',
    'board-level': 'Component-level soldering work',
    'button-repair': 'Side, home or power button not working',
    'earpiece-repair': 'Can\'t hear calls or muffled audio',
    'fingerprint-sensor': 'Touch ID not recognising or responding',
    'headphone-jack': 'No audio or intermittent connection',
    'housing-repair': 'Bent frame or damaged casing',
    'microphone-repair': 'Others can\'t hear you on calls',
    's-pen': 'S Pen not detected or not writing',
    'sensor': 'Proximity, gyro or other sensor fault',
    'sim-reader': 'No service or SIM not recognised',
    'software': 'Boot loops, freezes or software faults',
    'speaker-repair': 'No sound, crackling or distorted audio',
    'storage': 'Increase internal storage capacity',
    'vibration-motor': 'No vibration or stuck on vibrate',
    'wifi-signal': 'Weak signal, dropping or no connection',
    'wireless-charging': 'Won\'t charge wirelessly'
  };

  var WARN_REPAIRS = ['diagnosis', 'water-damage-diagnosis'];

  var DEFAULT_DIAGNOSIS_URLS = {
    phone: '/products/mobile-phone-diagnosis',
    'phone:water-damage-diagnosis': '/products/mobile-phone-water-damage-diagnosis',
    ipad: '/products/ipad-tablet-diagnosis',
    'ipad:water-damage-diagnosis': '/products/ipad-tablet-water-damage-diagnosis',
    macbook: '/products/macbook-diagnosis',
    'macbook:water-damage-diagnosis': '/products/macbook-logic-board-repair-quote-after-diagnosis',
    ipod: '/products/ipod-diagnosis',
    'ipod:water-damage-diagnosis': '/products/ipod-water-damage-diagnosis'
  };

  // ── Icons ──────────────────────────────────────────────────────────────────

  var ICONS = {
    phone: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="18" r=".5" fill="currentColor" stroke="none"/></svg>',
    ipad: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="18" rx="2"/><circle cx="18.5" cy="12" r=".6" fill="currentColor" stroke="none"/></svg>',
    macbook: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="13" rx="2"/><path d="M0 21h24"/></svg>',
    ipod: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="3"/><circle cx="12" cy="15" r="2.5"/><line x1="12" y1="6" x2="12" y2="8"/></svg>',
    brand: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    model: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>',
    'screen-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M9 7l2 2-2 2M13 7l2 2-2 2"/></svg>',
    'battery-replacement': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="10" rx="2"/><line x1="22" y1="11" x2="22" y2="13"/><line x1="6" y1="11" x2="6" y2="13"/></svg>',
    'charging-port-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
    'back-glass-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M9 7l6 10M15 7l-6 10"/></svg>',
    'rear-camera-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    'camera-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    'diagnosis': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r=".5" fill="currentColor" stroke="none"/></svg>',
    'water-damage-diagnosis': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C6 2 2 9 2 13a10 10 0 0 0 20 0c0-4-4-11-10-11z"/></svg>',
    'keyboard-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8"/></svg>',
    'trackpad-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="18" rx="2"/><line x1="2" y1="14" x2="22" y2="14"/><line x1="12" y1="14" x2="12" y2="21"/></svg>',
    'logic-board-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>',
    'camera-lens-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/><circle cx="12" cy="13" r="1.5" fill="currentColor" stroke="none"/></svg>',
    'front-camera': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    'board-level': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>',
    'button-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/></svg>',
    'earpiece-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z"/><path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>',
    'fingerprint-sensor': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4"/><path d="M5 19.5C5.5 18 6 15 6 12c0-1.7.7-3.2 1.8-4.3"/><path d="M17.5 20.5C17 19 17 17 17 16c0-2.5-.8-4.8-2.2-6.6"/><path d="M10 21C10 17 10.5 14.5 12 13c1.5-1.5 3-2 3-5 0-2.2-1.8-4-4-4S7 5.8 7 8"/><path d="M10 21c.5-3 2-4.5 2-8 0-1.1.4-2.1 1-2.8"/></svg>',
    'headphone-jack': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z"/><path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>',
    'housing-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
    'microphone-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>',
    's-pen': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>',
    'sensor': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2"/><path d="M16.24 7.76a6 6 0 0 1 0 8.49"/><path d="M7.76 16.24a6 6 0 0 1 0-8.49"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M4.93 19.07a10 10 0 0 1 0-14.14"/></svg>',
    'sim-reader': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M15 2v5h-6V2"/><rect x="8" y="12" width="8" height="6" rx="1"/></svg>',
    'software': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>',
    'speaker-repair': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>',
    'storage': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>',
    'vibration-motor': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h1m18 0h1M5 5l.7.7m12.6 12.6.7.7M5 19l.7-.7m12.6-12.6.7-.7"/><circle cx="12" cy="12" r="4"/><path d="M12 8v1m0 6v1m-4-4h1m6 0h1"/></svg>',
    'wifi-signal': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><circle cx="12" cy="20" r="1" fill="currentColor" stroke="none"/></svg>',
    'wireless-charging': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><circle cx="12" cy="20" r="1" fill="currentColor" stroke="none"/><path d="M13 6l-2 4h4l-2 4"/></svg>',
    browse: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>',
    check: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    back: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
    reset: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.5"/></svg>',
    chevron: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'
  };
  // Foldable screen repairs reuse the screen icon
  ICONS['cover-screen-repair'] = ICONS['screen-repair'];
  ICONS['inner-screen-repair'] = ICONS['screen-repair'];

  // ── Helpers ────────────────────────────────────────────────────────────────

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hasValue(v) {
    return String(v || '').trim().length > 0;
  }

  function normalizeBrand(brand) {
    var val = String(brand || '').trim();
    if (val === 'Google' || val === 'Google Pixel') return 'Google Pixel';
    return val;
  }

  function valueForKey(route, key) {
    if (key === 'brand') return normalizeBrand(route[key]);
    return route[key];
  }

  function uniqueValues(routes, key, labelKey, labelMap) {
    var seen = {};
    var result = [];
    routes.forEach(function (r) {
      var val = valueForKey(r, key);
      if (!hasValue(val) || seen[val]) return;
      seen[val] = true;
      result.push({
        value: val,
        label: (labelKey && r[labelKey]) || (labelMap && labelMap[val]) || val
      });
    });
    return result.sort(function (a, b) { return a.label.localeCompare(b.label); });
  }

  function filterRoutes(routes, filters) {
    return routes.filter(function (r) {
      return (!filters.category || r.device_category === filters.category) &&
        (!filters.brand    || normalizeBrand(r.brand) === filters.brand) &&
        (!filters.model    || r.model === filters.model);
    });
  }

  function getDefaultFallback(category, repairType, fallbackUrl) {
    var key = category + ':' + repairType;
    return DEFAULT_DIAGNOSIS_URLS[key] || DEFAULT_DIAGNOSIS_URLS[category] || fallbackUrl || DEFAULT_DIAGNOSIS_URLS.phone;
  }

  function resolveRoute(route, fallbackUrl) {
    if (!route) return fallbackUrl || DEFAULT_DIAGNOSIS_URLS.phone;
    return route.product_url ||
      route.model_collection_url ||
      route.aggregator_url ||
      route.brand_hub_url ||
      route.fallback_url ||
      getDefaultFallback(route.device_category, route.repair_type, fallbackUrl);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function track(event, data) {
    if (typeof window.srTrack !== 'function') return;
    window.srTrack(event, Object.assign({
      component: 'repair_finder',
      page_path: window.location.pathname
    }, data || {}));
  }

  // ── Wizard ─────────────────────────────────────────────────────────────────

  function initWizard(root, routeMap) {
    var stepsEl = root.querySelector('[data-sr-steps]');
    var bodyEl  = root.querySelector('[data-sr-body]');
    var fallbackUrl = root.getAttribute('data-fallback-url') || DEFAULT_DIAGNOSIS_URLS.phone;
    var headingText = root.getAttribute('data-heading') || 'Find your repair';
    var isDesignMode = root.getAttribute('data-design-mode') === 'true';
    var reviewEnabled = root.getAttribute('data-review-enabled') === 'true';
    var reviewScore = root.getAttribute('data-review-score') || '';
    var reviewCount = root.getAttribute('data-review-count') || '';
    var reviewUrl = root.getAttribute('data-review-url') || '';
    var reviewAriaLabel = root.getAttribute('data-review-aria-label') || '';

    var state = { step: 0, category: null, brand: null, model: null };
    var modelSearchTracked = false;
    var modelSearchNoResults = {};

    if (!Array.isArray(routeMap) || !routeMap.length) {
      track('repair_finder_error', {
        error_type: 'route_map_empty'
      });
      bodyEl.innerHTML = '<p class="sr-repair-finder__error">Repair data is unavailable. Please <a href="/pages/contact">contact us</a>.</p>';
      return;
    }

    track('repair_finder_loaded', {
      route_count: routeMap.length
    });

    // ── Steps bar ──────────────────────────────────────────────────────────

    function renderSteps() {
      var defs = [
        { caption: 'Device', value: state.category ? (CATEGORY_LABELS[state.category] || state.category) : null },
        { caption: 'Brand',  value: state.brand },
        { caption: 'Model',  value: state.model },
        { caption: 'Issue',  value: null }
      ];

      var html = '<span class="sr-repair-finder__steps-label">' + esc(headingText) + '</span>';
      html += '<button class="sr-repair-finder__steps-reset" type="button" data-sr-reset>' + ICONS.reset + ' Start over</button>';

      defs.forEach(function (def, i) {
        var mod = i < state.step ? 'done' : i === state.step ? 'active' : 'inactive';
        var numHtml = i < state.step ? ICONS.check : String(i + 1);
        var valDisplay = def.value ? esc(def.value) : (i === state.step ? '&hellip;' : '&mdash;');
        var goAttr = i < state.step ? ' data-sr-goto="' + i + '" role="button" tabindex="0"' : '';

        html += '<div class="sr-repair-finder__step sr-repair-finder__step--' + mod + '"' + goAttr + '>';
        html += '<div class="sr-repair-finder__step-inner">';
        html += '<div class="sr-repair-finder__step-num">' + numHtml + '</div>';
        html += '<div class="sr-repair-finder__step-text">';
        html += '<div class="sr-repair-finder__step-caption">' + esc(def.caption) + '</div>';
        html += '<div class="sr-repair-finder__step-value">' + valDisplay + '</div>';
        html += '</div></div></div>';
      });

      stepsEl.innerHTML = html;

      stepsEl.querySelector('[data-sr-reset]').addEventListener('click', function () {
        track('repair_finder_reset', trackingState());
        goTo(0);
      });

      stepsEl.querySelectorAll('[data-sr-goto]').forEach(function (el) {
        function activate() { goTo(parseInt(el.getAttribute('data-sr-goto'), 10)); }
        el.addEventListener('click', activate);
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
        });
      });
    }

    // ── Step body ──────────────────────────────────────────────────────────

    function renderBody() {
      var html;
      if (state.step === 0) html = stepDevice();
      else if (state.step === 1) html = stepBrand();
      else if (state.step === 2) html = stepModel();
      else html = stepRepair();

      bodyEl.innerHTML = html;

      bodyEl.querySelectorAll('[data-sr-pick]').forEach(function (card) {
        function activate() {
          var key = card.getAttribute('data-sr-pick');
          var val = card.getAttribute('data-sr-val');
          var fromStep = state.step;
          if (key === 'category') { state.category = val; state.step = 1; }
          else if (key === 'brand') { state.brand = val; state.step = 2; }
          else if (key === 'model') { state.model = val; state.step = 3; }
          track('repair_finder_step_selected', Object.assign(trackingState(), {
            selected_key: key,
            selected_value: val,
            from_step: fromStep,
            to_step: state.step
          }));
          render();
        }
        card.addEventListener('click', activate);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
        });
      });

      var backBtn = bodyEl.querySelector('[data-sr-back]');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          track('repair_finder_back_clicked', Object.assign(trackingState(), {
            from_step: state.step,
            to_step: state.step - 1
          }));
          goTo(state.step - 1);
        });
      }

      var filterInput = bodyEl.querySelector('[data-sr-filter]');
      if (filterInput) {
        filterInput.addEventListener('input', function () {
          var q = filterInput.value.trim().toLowerCase();
          var resultCount = 0;
          bodyEl.querySelectorAll('[data-sr-pick="model"]').forEach(function (card) {
            var title = card.querySelector('.sr-repair-finder__card-title');
            var label = title ? title.textContent.toLowerCase() : '';
            if (!q || label.indexOf(q) !== -1) resultCount++;
          });

          if (!modelSearchTracked && q.length >= 2) {
            modelSearchTracked = true;
            track('repair_finder_model_search_used', Object.assign(trackingState(), {
              query_length: q.length,
              result_count: resultCount
            }));
          }
          if (q.length >= 2 && resultCount === 0 && !modelSearchNoResults[q]) {
            modelSearchNoResults[q] = true;
            track('repair_finder_model_search_no_results', Object.assign(trackingState(), {
              query_length: q.length,
              result_count: 0
            }));
          }

          bodyEl.querySelectorAll('[data-sr-pick="model"]').forEach(function (card) {
            var title = card.querySelector('.sr-repair-finder__card-title');
            var label = title ? title.textContent.toLowerCase() : '';
            card.style.display = (q && label.indexOf(q) === -1) ? 'none' : '';
          });
        });
        filterInput.focus();
      }
    }

    // ── Step renderers ─────────────────────────────────────────────────────

    function stepDevice() {
      var categories = uniqueValues(routeMap, 'device_category', 'device_category_label', CATEGORY_LABELS);
      var html = h2('What type of device?');
      html += '<div class="sr-repair-finder__grid">';
      categories.forEach(function (cat) {
        html += wizardCard('category', cat.value, ICONS[cat.value] || ICONS.brand, cat.label, '');
      });
      html += '</div>';
      return html;
    }

    function stepBrand() {
      var filtered = filterRoutes(routeMap, { category: state.category });
      var brands = uniqueValues(filtered, 'brand');
      var html = h2('Who made it?');
      html += '<div class="sr-repair-finder__grid sr-repair-finder__grid--text">';
      brands.forEach(function (b) {
        html += wizardCard('brand', b.value, ICONS.brand, b.label, '');
      });
      html += '</div>';
      html += backButton();
      return html;
    }

    function modelSortKey(label) {
      var num = parseInt((label.match(/\d+/) || ['0'])[0], 10);
      var l = label.toLowerCase();
      var sub = l.indexOf('pro max') !== -1 ? 3
              : l.indexOf('pro')     !== -1 ? 2
              : l.indexOf('plus')    !== -1 ? 1
              : l.indexOf('mini')    !== -1 ? -1
              : 0;
      return { num: num, sub: sub };
    }

    function stepModel() {
      var filtered = filterRoutes(routeMap, { category: state.category, brand: state.brand });
      var models = uniqueValues(filtered, 'model');
      models.sort(function (a, b) {
        var ka = modelSortKey(a.label), kb = modelSortKey(b.label);
        if (kb.num !== ka.num) return kb.num - ka.num;
        return kb.sub - ka.sub;
      });
      var html = h2('Which model?');
      if (models.length > 8) {
        html += '<div class="sr-repair-finder__filter-wrap">'
          + '<svg class="sr-repair-finder__filter-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
          + '<input class="sr-repair-finder__filter" type="search" placeholder="Search models…" data-sr-filter autocomplete="off" spellcheck="false">'
          + '</div>';
      }
      html += '<div class="sr-repair-finder__grid sr-repair-finder__grid--text">';
      models.forEach(function (m) {
        html += wizardCard('model', m.value, ICONS.model, m.label, '');
      });
      html += '</div>';
      html += backButton();
      return html;
    }

    function stepRepair() {
      var filtered = filterRoutes(routeMap, { category: state.category, brand: state.brand, model: state.model });
      var repairs = uniqueValues(filtered, 'repair_type', 'repair_label', REPAIR_LABELS);

      var collectionUrl = null;
      for (var i = 0; i < filtered.length; i++) {
        if (filtered[i].model_collection_url) { collectionUrl = filtered[i].model_collection_url; break; }
      }

      var html = h2(repairs.length ? 'What\'s the issue?' : state.model + ' repairs');
      html += '<div class="sr-repair-finder__grid">';

      repairs.forEach(function (repair) {
        var isWarn = WARN_REPAIRS.indexOf(repair.value) !== -1;
        var icon = ICONS[repair.value] || ICONS.diagnosis;
        var desc = REPAIR_DESCS[repair.value] || '';

        var route = null;
        for (var j = 0; j < filtered.length; j++) {
          if (filtered[j].repair_type === repair.value) { route = filtered[j]; break; }
        }
        var url = route ? resolveRoute(route, fallbackUrl) : getDefaultFallback(state.category, repair.value, fallbackUrl);

        html += linkCard(icon, repair.label, desc, url, isWarn ? 'warn' : '', {
          repair_type: repair.value,
          repair_label: repair.label,
          destination_type: route && route.product_url ? 'product' : 'fallback'
        });
      });

      if (collectionUrl) {
        html += linkCard(
          ICONS.browse,
          'View all ' + esc(state.model) + ' repairs',
          'Browse every repair available for this model',
          collectionUrl,
          'browse',
          {
            repair_type: 'all_repairs',
            repair_label: 'View all repairs',
            destination_type: 'collection'
          }
        );
      }

      if (!repairs.length && isDesignMode) {
        html += '<p class="sr-repair-finder__error">Admin note: this model is in the finder, but no repair product routes are linked yet.</p>';
      }

      html += '</div>';
      if (reviewEnabled && reviewScore && reviewCount && reviewUrl) {
        html += '<a class="sr-repair-finder__review-trust" href="' + esc(reviewUrl) + '"'
          + ' target="_blank" rel="noopener noreferrer" aria-label="' + esc(reviewAriaLabel) + '">'
          + '<span class="sr-repair-finder__review-stars" aria-hidden="true">★★★★★</span>'
          + '<span><strong>' + esc(reviewScore) + '</strong> on Google · ' + esc(reviewCount) + ' reviews</span>'
          + '<span aria-hidden="true">↗</span>'
          + '</a>';
      }
      html += backButton();
      return html;
    }

    // ── HTML builders ──────────────────────────────────────────────────────

    function h2(text) {
      return '<h2 class="sr-repair-finder__heading">' + esc(text) + '</h2>';
    }

    function wizardCard(key, val, icon, label, desc) {
      return '<button class="sr-repair-finder__card" type="button"'
        + ' data-sr-pick="' + esc(key) + '"'
        + ' data-sr-val="' + esc(val) + '"'
        + ' tabindex="0">'
        + '<div class="sr-repair-finder__card-icon">' + icon + '</div>'
        + '<div class="sr-repair-finder__card-text">'
        + '<div class="sr-repair-finder__card-title">' + esc(label) + '</div>'
        + (desc ? '<div class="sr-repair-finder__card-desc">' + esc(desc) + '</div>' : '')
        + '</div>'
        + '<span class="sr-repair-finder__card-arrow">' + ICONS.chevron + '</span>'
        + '</button>';
    }

    function attrs(data) {
      var html = '';
      Object.keys(data || {}).forEach(function (key) {
        if (data[key] == null) return;
        html += ' data-' + key.replace(/_/g, '-') + '="' + esc(data[key]) + '"';
      });
      return html;
    }

    function linkCard(icon, label, desc, url, variant, data) {
      var cls = 'sr-repair-finder__card' + (variant ? ' sr-repair-finder__card--' + variant : '');
      return '<a class="' + cls + '" href="' + esc(url) + '" data-sr-result' + attrs(data) + '>'
        + '<div class="sr-repair-finder__card-icon">' + icon + '</div>'
        + '<div class="sr-repair-finder__card-text">'
        + '<div class="sr-repair-finder__card-title">' + esc(label) + '</div>'
        + (desc ? '<div class="sr-repair-finder__card-desc">' + esc(desc) + '</div>' : '')
        + '</div>'
        + '<span class="sr-repair-finder__card-arrow">' + ICONS.chevron + '</span>'
        + '</a>';
    }

    function backButton() {
      return '<button class="sr-repair-finder__back" type="button" data-sr-back>'
        + ICONS.back + ' Back'
        + '</button>';
    }

    // ── Navigation ─────────────────────────────────────────────────────────

    function goTo(step) {
      state.step = step;
      if (step <= 0) { state.category = null; state.brand = null; state.model = null; }
      else if (step === 1) { state.brand = null; state.model = null; }
      else if (step === 2) { state.model = null; }
      render();
    }

    function trackingState() {
      return {
        step: state.step,
        device_category: state.category || '',
        brand: state.brand || '',
        model: state.model || ''
      };
    }

    // ── Render ─────────────────────────────────────────────────────────────

    function render() {
      renderSteps();
      renderBody();

      bodyEl.querySelectorAll('[data-sr-result]').forEach(function (card) {
        card.addEventListener('click', function () {
          track('repair_finder_result_clicked', Object.assign(trackingState(), {
            repair_type: card.getAttribute('data-repair-type') || '',
            repair_label: card.getAttribute('data-repair-label') || '',
            destination_type: card.getAttribute('data-destination-type') || '',
            destination_url: card.getAttribute('href') || ''
          }));
        });
      });
    }

    render();
  }

  // ── Loader ─────────────────────────────────────────────────────────────────

  function loadFinder(root) {
    var routeMapUrl = root.getAttribute('data-route-map-url') ||
      (window.SR_REPAIR_FINDER && window.SR_REPAIR_FINDER.routeMapUrl);

    if (!routeMapUrl) { initWizard(root, []); return; }

    fetch(routeMapUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Route map request failed');
        return res.json();
      })
      .then(function (routeMap) { initWizard(root, routeMap); })
      .catch(function () { initWizard(root, []); });
  }

  ready(function () {
    document.querySelectorAll('[data-sr-repair-finder]').forEach(function (root) {
      var started = false;
      var observer;
      function start() {
        if (started) return;
        started = true;
        if (observer) observer.disconnect();
        root.removeEventListener('pointerdown', start);
        root.removeEventListener('focusin', start);
        loadFinder(root);
      }
      root.addEventListener('pointerdown', start, { once: true });
      root.addEventListener('focusin', start, { once: true });
      if (root.getAttribute('data-design-mode') === 'true' || !('IntersectionObserver' in window)) {
        start();
        return;
      }
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) start();
      }, { rootMargin: '300px 0px' });
      observer.observe(root);
    });
  });

  window.SRRepairFinder = { filterRoutes: filterRoutes, resolveRoute: resolveRoute };

})();
